import React from 'react';

import type { FC } from 'react';

export const SwapVert: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M15.9947 17.0149V11.0049C15.9947 10.4549 15.5447 10.0049 14.9947 10.0049C14.4447 10.0049 13.9947 10.4549 13.9947 11.0049V17.0149H12.2047C11.7547 17.0149 11.5347 17.5549 11.8547 17.8649L14.6447 20.6449C14.8447 20.8349 15.1547 20.8349 15.3547 20.6449L18.1447 17.8649C18.4647 17.5549 18.2347 17.0149 17.7947 17.0149H15.9947ZM8.64466 3.3549L5.85466 6.1449C5.53466 6.4549 5.75466 6.9949 6.20466 6.9949H7.99466V13.0049C7.99466 13.5549 8.44466 14.0049 8.99466 14.0049C9.54466 14.0049 9.99466 13.5549 9.99466 13.0049V6.9949H11.7847C12.2347 6.9949 12.4547 6.4549 12.1347 6.1449L9.34466 3.3549C9.15466 3.1649 8.83466 3.1649 8.64466 3.3549Z"
        fill="#BDCFCF"
      />
    </svg>
  );
};
